import { render, staticRenderFns } from "./memory.vue?vue&type=template&id=03ad7fec&scoped=true&"
import script from "./memory.vue?vue&type=script&lang=ts&"
export * from "./memory.vue?vue&type=script&lang=ts&"
import style0 from "./memory.vue?vue&type=style&index=0&id=03ad7fec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ad7fec",
  null
  
)

export default component.exports